const mEditionBillingAcademyBilling = {
  mEditionBillingAcademyBilling: {
    alerts: {
      readFacturacion: {
        error: 'Un error ha ocurrido al cargar la facturación. Vuelve a intentarlo en un momento.'
      },

      readTotales: {
        error: 'Un error ha ocurrido al cargar los totales. Vuelve a intentarlo en un momento.'
      }
    },

    filters: {
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      productLabel: 'Producto (uuid)',
      productPlaceholder: 'uuid del producto',
      urlLabel: 'Academia',
      urlPlaceholder: 'url de la academia'
    },

    labels: {
      academyStateActive: 'Activa',
      academyStateHidden: 'Oculta',
      freeLicense: 'Gratis',
      licenseActive: 'Licencia activa',
      licenseInactive: 'Licencia inactiva',
      never: ' - ',
      noData: 'No hay facturación para los filtros seleccionados.',
      noLicense: 'Sin licencia',
      paidLicense: 'Paga',
      payments: 'pagos',
      sales: 'ventas'
    },

    lock: {
      button: 'Ingresar',
      description: 'Esta sección contiene información sensible de facturación. Ingresá la contraseña para continuar.',
      error: 'Contraseña incorrecta. Volvé a intentarlo.',
      placeholder: 'Contraseña',
      title: 'Panel protegido'
    },

    summary: {
      academies: 'academias',
      hint: '(totales globales del filtro · click en una tarjeta para filtrar el listado por esa divisa)',
      payments: 'pagos',
      title: 'Total facturado por divisa'
    },

    table: {
      thAcademy: 'Academia',
      thState: 'Estado',
      thLicense: 'Licencia',
      thSales: 'Ventas / Pagos',
      thFirstPayment: 'Primer pago',
      thLastPayment: 'Último pago',
      thTotals: 'Total facturado',
      thProducts: 'Productos',
      thBuyers: 'Compradores'
    },

    tooltip: {
      buyers: 'Ver top compradores',
      reload: 'Limpiar filtros y recargar',
      search: 'Buscar'
    }
  },

  mEditionBillingAcademyBillingModalBuyers: {
    alerts: {
      readCompradores: {
        error: 'Un error ha ocurrido al cargar los compradores. Vuelve a intentarlo en un momento.'
      }
    },

    close: 'CERRAR',
    loadMore: 'Cargar más',
    noData: 'No hay compradores para la divisa seleccionada.',
    payments: 'pagos',
    sales: 'ventas',
    subtitle: 'Ranking de compradores ordenado por total comprado (de mayor a menor). Elegí la divisa para ver su ranking.',
    title: 'TOP COMPRADORES'
  },

  mEditionBillingAcademyBillingModalProducts: {
    close: 'CERRAR',
    subtitle: 'Productos con pagos registrados. Copiá el uuid o filtrá el listado directamente.',
    title: 'PRODUCTOS FACTURADOS',

    tooltip: {
      copied: '¡Copiado!',
      copy: 'Copiar uuid',
      filter: 'Filtrar listado por este producto'
    }
  }
}

export default mEditionBillingAcademyBilling
